/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                      i18n => localization,
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import onboardingService from "../core/services/onboardingService";

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.HOST,
    scrollBehavior(to, from) {
        // Only not scroll top when moving from offer to offerInfo
        if (from.name === "offer" && to.name === "offerInfo") {
            return {};
        }
        if (from.name === "order-report-detail" && to.name === "order-report-detail") {
            return {};
        }

        return { x: 0, y: 0 }
    },
    routes: [
        {
            path: '/pages/error-404',
            name: 'page-error-404',
            meta: {
                auth: undefined
            },
            component: () => import('@/views/pages/Error404.vue')
        },
        {
            path: "/digibank",
            name: "events-digibank",
            meta: {
                auth: undefined,
            },
            component: () => import("@/views/pages/events/Digibank.vue"),
        },
        {
            path: "/finbank",
            name: "events-digibank",
            meta: {
                auth: true,
            },
            component: () => import("@/views/pages/events/Finbank.vue"),
        },
        {
            path: '',
            redirect: '/dashboard',
            component: () => import('../layouts/main/Main.vue'),
            children: [
                {
                    path: '/dashboard',
                    name: 'home',
                    meta: {
                        auth: true,
                        pageTitle: 'Trang chủ',
                        i18n: 'router.home',
                    },
                    component: () => import('@/views/Home.vue')
                },
                {
                    path: '/user/profile',
                    redirect: '/user/profile/general'
                },
                {
                    path: '/user/profile/:tab',
                    name: 'user-profile',
                    meta: {
                        auth: true,
                        breadcrumb: [
                            { title: 'Home', url: '/dashboard' },
                            { title: 'Thông tin cá nhân', active: true, i18n: 'router.userProfile' },
                        ],
                        pageTitle: 'Thông tin cá nhân',
                        i18n: 'router.userProfile',
                    },
                    component: () => import('@/views/user/UserSettings.vue'),
                    beforeEnter: (to, from, next) => {
                      const tabs = [
                        { name: 'general'},
                        { name: 'password' },
                        { name: 'info'},
                        { name: 'payment', title: 'router.userProfilePayment' },
                        { name: 'social' },
                        { name: 'token'},
                        { name: 'notification' },
                        { name: 'history'},
                        { name: 'advertisement'}
                    ];

                    checkTabPathTitle(to, from, next, tabs);
                    }
                },
                {
                    path: '/offer',
                    name: 'offer',
                    component: () => import('@/views/offer/Offer.vue'),
                    meta: {
                        auth: true,
                        pageTitle: 'Chiến dịch',
                        i18n: 'router.offer',
                        breadcrumb: [
                            { title: 'Trang chủ', url: '/' },
                            { title: 'Đối tác', active: true, i18n: 'router.offer' },
                        ],
                    }
                },
                {
                    path: '/offer/:offerId/info',
                    name: 'offerInfo',
                    component: () => import('@/views/offer/OfferInfo.vue'),
                    meta: {
                        auth: true,
                        pageTitle: 'Thông tin chiến dịch',
                        i18n: 'router.offerInfo',
                        breadcrumb: [
                            { title: 'Trang chủ', url: '/' },
                            { title: 'Chiến dịch', url: '/offer', i18n: 'router.offer' },
                            { title: 'Thông tin chiến dịch', active: true, i18n: 'router.offerInfo' },
                        ],
                        parent: "offer"
                    }
                },
                {
                    path: '/news',
                    name: 'news',
                    component: () => import('@/views/news/News.vue'),
                    meta: {
                        auth: true,
                        pageTitle: 'Tin tức & Ưu đãi',
                        i18n: 'router.news',
                        breadcrumb: [
                            { title: 'Trang chủ', url: '/' },
                            { title: 'Tin tức & Ưu đãi', active: true, i18n: 'router.news' },
                        ],
                    }
                },
                {
                    path: '/news/:slug',
                    name: 'news-detail',
                    component: () => import('@/views/news/NewsDetail.vue'),
                    meta: {
                        auth: true,
                        pageTitle: 'Chi tiết tin tức',
                        i18n: 'router.newsDetail',
                        breadcrumb: [
                            { title: 'Trang chủ', url: '/' },
                            { title: 'Tin tức', active: true, i18n: 'router.news' },
                        ],
                    }
                },
                {
                    path: '/report/order',
                    name: 'order-report',
                    component: () => import('@/views/report/order/Order.vue'),
                    meta: {
                        auth: true,
                        pageTitle: 'Báo cáo đơn hàng',
                        i18n: 'router.orderReport',
                        breadcrumb: [
                            { title: 'Trang chủ', url: '/' },
                            { title: 'Báo cáo', active: true, i18n: 'router.report' },
                            { title: 'Báo cáo đơn hàng', active: true, i18n: 'router.orderReport' },
                        ],
                    }
                },
                {
                    path: '/report/order/detail',
                    name: 'order-report-detail',
                    component: () => import('@/views/report/order/OrderDetail.vue'),
                    meta: {
                        auth: true,
                        pageTitle: 'Chi tiết đơn hàng',
                        i18n: 'router.orderReportDetail',
                        breadcrumb: [
                            { title: 'Trang chủ', url: '/' },
                            { title: 'Báo cáo', active: true, i18n: 'router.report' },
                        ],
                        // parent: "order-report"
                    }
                },
                // {
                //     path: '/report/performance',
                //     name: 'order-performance',
                //     component: () => import('./views/report/performance/Performance.vue'),
                //     meta: {
                //         auth: true,
                //         pageTitle: 'Báo cáo hiệu quả',
                //         i18n: 'router.performanceReport',
                //         breadcrumb: [
                //             { title: 'Trang chủ', url: '/' },
                //             { title: 'Báo cáo', active: true, i18n: 'router.report' },
                //             { title: 'Báo cáo hiệu quả', active: true, i18n: 'router.performanceReport' },
                //         ],
                //     }
                // },

                // @deprecate
                // {
                //     path: '/report/revenue',
                //     name: 'revenue-report',
                //     component: () => import('./views/report/revenue/Revenue.vue'),
                //     meta: {
                //         auth: true,
                //         pageTitle: 'Báo cáo doanh thu',
                //         i18n: 'router.revenueReport',
                //         breadcrumb: [
                //             { title: 'Trang chủ', url: '/' },
                //             { title: 'Báo cáo', active: true, i18n: 'router.report' },
                //             { title: 'Báo cáo doanh thu', active: true, i18n: 'router.revenueReport' },
                //         ],
                //     }
                // },
                {
                    path: '/report/invoice',
                    name: 'invoice-report',
                    component: () => import('@/views/report/invoice/Invoice.vue'),
                    meta: {
                        auth: true,
                        pageTitle: 'Thanh toán',
                        i18n: 'router.pay',
                        breadcrumb: [
                            { title: 'Trang chủ', url: '/' },
                            { title: 'Báo cáo', active: true, i18n: 'router.report' },
                            { title: 'Thanh toán', active: true, i18n: 'router.paymentHistory' },
                        ],
                    }
                },
                {
                    path: '/report/invoice/:invoiceID',
                    name: 'invoice-report-detail',
                    component: () => import('@/views/report/invoice/InvoiceDetail.vue'),
                    meta: {
                        auth: true,
                        pageTitle: 'Thanh toán',
                        i18n: 'router.pay',
                        breadcrumb: [
                            { title: 'Trang chủ', url: '/' },
                            { title: 'Báo cáo', active: true, i18n: 'router.report' },
                            { title: 'Thanh toán', url: '/report/invoice', i18n: 'router.paymentHistory' },
                            { title: 'Chi tiết invoice', active: true, i18n: 'router.invoiceDetail' },
                        ],
                    }
                },
                {
                    path: '/tool/created-links',
                    name: 'created-links',
                    component: () => import('@/views/tools/createdLinks/CreatedLinks.vue'),
                    meta: {
                        auth: true,
                        pageTitle: 'Link đã tạo',
                        i18n: 'router.createdLink',
                        breadcrumb: [
                            { title: 'Trang chủ', url: '/' },
                            { title: 'Công cụ', active: true, i18n: 'router.tools' },
                            { title: 'Link đã tạo', active: true, i18n: 'router.createdLink' },
                        ],
                    }
                },
                {
                    path: '/tool/parking-domain',
                    name: 'parking-domain',
                    component: () => import('@/views/tools/parkingDomain/ParkingDomain.vue'),
                    meta: {
                        auth: true,
                        pageTitle: 'Parking Domain',
                        i18n: 'router.parkingDomain',
                        breadcrumb: [
                            { title: 'Trang chủ', url: '/' },
                            { title: 'Công cụ', active: true, i18n: 'router.tools' },
                            { title: 'Parking Domain', active: true, i18n: 'router.parkingDomain' },
                        ],
                    }
                },
                {
                    path: '/tool/hyperlead-api',
                    redirect: '/tool/hyperlead-api/offers'
                },
                {
                    path: '/tool/hyperlead-api/:tab',
                    name: 'hyperlead-api',
                    component: () => import('@/views/tools/masofferAPI/APIList.vue'),
                    beforeEnter: (to, from, next) => {
                        var tabs = [
                            'offers',
                            'conversions'
                        ];

                        checkTabPath(to, from, next, tabs);
                    },
                    meta: {
                        auth: true,
                        pageTitle: 'HyperLead\'s API',
                        i18n: 'router.masofferAPI',
                        breadcrumb: [
                            { title: 'Trang chủ', url: '/' },
                            { title: 'Công cụ', active: true, i18n: 'router.tools' },
                            { title: 'HyperLead\'s API', active: true, i18n: 'router.masofferAPI' },
                        ],
                        parent: 'hyperlead-api'
                    }
                },
                {
                    path: '/tool/postback',
                    name: 'postback',
                    component: () => import('@/views/tools/postback/Postback.vue'),
                    meta: {
                        auth: true,
                        pageTitle: 'Postback',
                        i18n: 'router.postback',
                        breadcrumb: [
                            { title: 'Trang chủ', url: '/' },
                            { title: 'Công cụ', active: true, i18n: 'router.tools' },
                            { title: 'Postback', active: true, i18n: 'router.postback' },
                        ],
                    }
                },
                {
                    path: '/tool/postback/add',
                    name: 'postback-add',
                    component: () => import('@/views/tools/postback/Add.vue'),
                    meta: {
                        auth: true,
                        pageTitle: 'Thêm Postback',
                        i18n: 'router.addPostback',
                        breadcrumb: [
                            { title: 'Trang chủ', url: '/' },
                            { title: 'Công cụ', active: true, i18n: 'router.tools' },
                            { title: 'Postback', active: true, i18n: 'router.postback', url: '/tool/postback' },
                            { title: 'Thêm Postback', active: true, i18n: 'router.addPostback' },
                        ],
                        parent: "postback"
                    },
                },
                {
                    path: '/tool/postback/:postbackID',
                    name: 'postback-edit',
                    component: () => import('@/views/tools/postback/Edit.vue'),
                    meta: {
                        auth: true,
                        pageTitle: 'Sửa Postback',
                        i18n: 'router.editPostback',
                        breadcrumb: [
                            { title: 'Trang chủ', url: '/' },
                            { title: 'Công cụ', active: true, i18n: 'router.tools' },
                            { title: 'Postback', active: true, i18n: 'router.postback', url: '/tool/postback' },
                            { title: 'Sửa Postback', active: true, i18n: 'router.editPostback' },
                        ],
                        parent: "postback"
                    },
                },

                // Hide ticket feature HP-1791
                // {
                //     path: 'support/ticket-manage/',
                //     name: 'ticket-manage',
                //     component: () => import('@/views/support/ticket/Ticket.vue'),
                //     meta: {
                //         auth: true,
                //         pageTitle: 'Ticket',
                //         i18n: 'router.ticketManage',
                //         breadcrumb: [
                //             { title: 'Trang chủ', url: '/', i18n: 'router.home' },
                //             { title: 'Hỗ trợ', active: true, i18n: 'router.support' },
                //             { title: 'Ticket', active: true, i18n: 'router.ticketManage'  },
                //         ],
                //     }
                // },
                {
                    path: 'support/ticket-manage/create',
                    name: 'ticket-create',
                    component: () => import('@/views/support/ticket/TicketCreate.vue'),
                    meta: {
                        auth: true,
                        pageTitle: 'Gửi Ticket',
                        i18n: 'router.ticketCreate',
                        breadcrumb: [
                            { title: 'Trang chủ', url: '/', i18n: 'router.home' },
                            { title: 'Hỗ trợ', active: true, i18n: 'router.support' },
                            { title: 'Gửi Ticket', active: true, i18n: 'router.ticketCreate' },
                        ],
                        parent: "ticket-manage"
                    }
                },
                {
                    path: 'support/ticket-manage/detail/:id',
                    name: 'ticket-detail',
                    component: () => import('@/views/support/ticket/TicketDetail.vue'),
                    meta: {
                        auth: true,
                        pageTitle: 'Chi tiết Ticket',
                        i18n: 'router.ticketDetail',
                        breadcrumb: [
                            { title: 'Trang chủ', url: '/', i18n: 'router.home' },
                            { title: 'Hỗ trợ', active: true, i18n: 'router.support' },
                            { title: 'Quản lý Ticket', active: true, url: '/support/ticket-manage', i18n: 'router.ticketManage' },
                            { title: 'Chi tiết Ticket', active: true, i18n: 'router.ticketDetail' },
                        ],
                        parent: 'ticket-manage'
                    }
                },
                {
                    path: 'support/policies',
                    redirect: 'support/policies/regulation'
                },
                {
                    path: 'support/policies/:tab',
                    name: 'support-policies',
                    component: () => import('@/views/support/policies/Policies.vue'),
                    beforeEnter: (to, from, next) => {
                        var tabs = [
                            'regulation',
                            'payment'
                        ];

                        checkTabPath(to, from, next, tabs);
                    },
                    meta: {
                        auth: true,
                        pageTitle: 'Quy định & Chính sách',
                        i18n: 'router.termsAndConditions',
                        breadcrumb: [
                            { title: 'Trang chủ', url: '/' },
                            { title: 'Hỗ trợ', active: true, i18n: 'router.support' },
                            { title: 'Quy định & Chính sách', active: true, i18n: 'router.termsAndConditions' },
                        ],
                        parent: 'support-policies'
                    }
                },
                {
                    path: 'support/about',
                    name: 'support-about',
                    component: () => import('@/views/support/About.vue'),
                    meta: {
                        auth: true,
                        pageTitle: 'Giới thiệu về HyperLead',
                        i18n: 'router.aboutMasOffer',
                        breadcrumb: [
                            { title: 'Trang chủ', url: '/' },
                            { title: 'Hỗ trợ', active: true, i18n: 'router.support' },
                            { title: 'Về HyperLead', active: true, i18n: 'router.aboutMasOffer' },
                        ],
                    }
                },
                {
                    path: 'support/find-conversion',
                    name: 'support-find-conversion',
                    component: () => import('@/views/support/find-conversion/FindConversion.vue'),
                    meta: {
                        auth: true,
                        pageTitle: 'Tra cứu đơn',
                        i18n: 'router.findConversion',
                    }
                },
                {
                    path: '/loyalty',
                    name: 'loyalty',
                    component: () => import('@/views/loyalty/Loyalty.vue'),
                    meta: {
                        auth: true,
                        pageTitle: 'Loyalty',
                        i18n: 'router.loyalty',
                        breadcrumb: [
                            { title: 'Trang chủ', url: '/' },
                            { title: 'Loyalty', active: true, i18n: 'router.loyalty' },
                        ],
                    }
                },
                {
                    path: '/knowledge-base',
                    name: 'knowledge-base',
                    component: () => import('@/views/knowledge-base/Knowledge.vue'),
                    meta: {
                        auth: true,
                        pageTitle: 'Kiến thức cơ bản',
                        i18n: 'router.knowledgeBase',
                        breadcrumb: [
                            { title: 'Trang chủ', url: '/' },
                            { title: 'Kiến thức cơ bản', active: true, i18n: 'router.knowledgeBase' },
                        ],
                    }
                },
                {
                    path: '/knowledge-base/:parentSlug',
                    name: 'knowledge-base-category',
                    component: () => import('@/views/knowledge-base/CategoryDetail.vue'),
                    meta: {
                        auth: true,
                        parent: 'knowledge-base',
                        pageTitle: 'Danh mục',
                        i18n: 'router.knowledgeCategory',
                        breadcrumb: [
                            { title: 'Trang chủ', url: '/' },
                            { title: 'Kiến thức cơ bản', url: '/knowledge-base', i18n: 'router.knowledgeBase' },
                        ],
                    },
                },
                {
                    path: '/knowledge-base/:categorySlug/:postSlug',
                    name: 'knowledge-base-post',
                    component: () => import('@/views/knowledge-base/Post.vue'),
                    meta: {
                        auth: true,
                        parent: 'knowledge-base',
                        pageTitle: 'Bài viết',
                        i18n: 'router.knowledgePost',
                        breadcrumb: [
                            { title: 'Trang chủ', url: '/' },
                            { title: 'Kiến thức cơ bản', url: '/knowledge-base', i18n: 'router.knowledgeBase' },
                        ],
                    },
                }
                // {
                //     path: '/tongketnam',
                //     name: 'hyperlead-wrapped',
                //     component: () => import('@/views/hyperlead-wrapped/Index.vue'),
                //     meta: {
                //         auth: true,
                //         pageTitle: 'Tổng kết năm',
                //         i18n: 'router.hyperleadWrapped',
                //         breadcrumb: [
                //             { title: 'Trang chủ', url: '/' },
                //             { title: 'Tổng kết năm', active: true, i18n: 'router.hyperleadWrapped' },
                //         ],
                //     }
                // },
                // {
                //     path: '/tongketnam/ketqua',
                //     name: 'hyperlead-wrapped-result',
                //     component: () => import('@/views/hyperlead-wrapped/Result.vue'),
                //     meta: {
                //         auth: true,
                //         pageTitle: 'Kết quả của bạn',
                //         i18n: 'router.hyperleadWrappedResult',
                //         parent: "hyperlead-wrapped"
                //     },
                //     beforeEnter: (to, from, next) => {
                //         if(sessionStorage.getItem('has_revenue') || !sessionStorage.getItem('seenable')){
                //             next({name: 'hyperlead-wrapped'})
                //         }else {
                //             next()
                //         }
                //     }
                // }
            ],
        },
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
                {
                    path: '/login',
                    name: 'page-login',
                    meta: {
                        auth: false,
                        i18n: 'router.login',
                        pageTitle: 'Đăng nhập'
                    },
                    component: () => import('@/views/pages/login/LoginJWT.vue')
                },
                {
                    path: '/register',
                    name: 'page-register',
                    meta: {
                        auth: false,
                        i18n: 'router.register',
                        pageTitle: 'Tạo tài khoản'
                    },
                    component: () => import('@/views/pages/register/Register.vue')
                },
                {
                    path: '/forgot-password',
                    name: 'forgot-password',
                    meta: {
                        auth: false
                    },
                    component: () => import('@/views/pages/ForgotPassword.vue')
                },
                {
                    path: '/reset-password/:verifyCode',
                    name: 'reset-password',
                    meta: {
                        auth: false
                    },
                    component: () => import('@/views/pages/ResetPassword.vue')
                },
                {
                    path: "/auth-verify/:token",
                    name: "auth-verify",
                    meta: {
                        // auth: false,
                    },
                    component: () => import("@/views/pages/AuthVerify.vue"),
                },
                {
                    path: '/thank-you/welcome-to-HyperLead',
                    name: 'thank-you',
                    meta: {
                        auth: false
                    },
                    component: () => import('@/views/pages/ThankYou.vue')
                },
                {
                    path: '/complete',
                    name: 'complete-page',
                    meta: {
                        auth: false
                    },
                    component: () => import('@/views/pages/Complete.vue')
                },
                {
                    path: '/terms-and-conditions',
                    name: 'terms-and-conditions',
                    component: () => import('@/views/pages/TermsAndConditions.vue')
                },
                {
                    path: "/verify-otp",
                    name: "verify-otp",
                    meta: {
                        auth: false,
                    },
                    component: () => import("@/views/pages/VerifyOTP.vue"),
                },
                {
                  path: "/authentication",
                  name: "authentication",
                  meta: {
                      auth: false,
                  },
                  component: () => import("@/views/pages/register/PickZalo.vue"),
              },
                // privacy policy
                {
                    path: '/privacy-policy',
                    name: 'privacy-policy',
                    component: () => import('@/views/pages/PrivacyPolicy.vue')
                },

                {
                    path: '/change-email/:type/:verifyCode',
                    name: 'verify-email',
                    component: () => import('@/views/pages/VerifyEmail.vue')
                },
                {
                    path: '/change-email/old_email/reject/:rejectCode',
                    name: 'reject-email',
                    component: () => import('@/views/pages/RejectEmail.vue')
                },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.beforeEach((to, from, next) => {
    if (to.name === 'page-login') {
        sessionStorage.removeItem('has_revenue');
    }
    next();
});

router.afterEach((to, from) => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
    document.querySelectorAll('body > div.vs-component').forEach(el => {
        el.remove()
    })
    document.querySelectorAll('body > div.vs-content-sidebar').forEach(el => {
        el.remove()
    })
    if (!(from.name === 'offer' && to.name === 'offerInfo') ||
        (from.name === 'offer' && to.name === 'advertisement') ) {
        Vue.prototype.$tours.onboarding.finish();
        onboardingService.setHasOnboarding(false);

    }
})

function checkTabPath(to, from, next, tabs) {
    if (!tabs.includes(to.params.tab)) {
        next({ name: 'page-error-404' });
    }

    next();
}

function checkTabPathTitle(to, from, next, tabs) {
  const tab = tabs.find(t => t.name === to.params.tab);

  if (!tab) {
      return next({ name: 'page-error-404' });
  }

  if (tab.title) {
      to.meta.i18n = tab.title;
  }

  next();
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js